export const AUTH_SESSION_STORAGE_KEYS = [
  'authData',
  'token',
  'username',
  'currentProject',
] as const;

export const clearStoredSession = (): void => {
  AUTH_SESSION_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
};
